/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecalculateUnprocessedTradesDto
 */
export interface RecalculateUnprocessedTradesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RecalculateUnprocessedTradesDto
     */
    portfolioIds: Array<string>;
}

export function RecalculateUnprocessedTradesDtoFromJSON(json: any): RecalculateUnprocessedTradesDto {
    return RecalculateUnprocessedTradesDtoFromJSONTyped(json, false);
}

export function RecalculateUnprocessedTradesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecalculateUnprocessedTradesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'portfolioIds': json['portfolioIds'],
    };
}

export function RecalculateUnprocessedTradesDtoToJSON(value?: RecalculateUnprocessedTradesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'portfolioIds': value.portfolioIds,
    };
}

